import Parse from "parse";

import type { Category } from "./Category";
import type { _User } from "./_User";

type OD3_Tenant = Parse.Object;

export interface DocumentAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  category: Category;
  content: string;
  createdBy: _User;
  icon?: string;
  order: number;
  tenant?: OD3_Tenant;
  title: string;
  updatedBy: _User;
  user?: _User;
}

export class Document extends Parse.Object<DocumentAttributes> {
  static className: string = "OD3_Documentation_Document";

  constructor(data?: Partial<DocumentAttributes>) {
    super("OD3_Documentation_Document", data as DocumentAttributes);
  }

  get category(): Category {
    return super.get("category");
  }
  set category(value: Category) {
    super.set("category", value);
  }
  get content(): string {
    return super.get("content");
  }
  set content(value: string) {
    super.set("content", value);
  }
  get createdBy(): _User {
    return super.get("createdBy");
  }
  set createdBy(value: _User) {
    super.set("createdBy", value);
  }
  get icon(): string | undefined {
    return super.get("icon");
  }
  set icon(value: string | undefined) {
    super.set("icon", value);
  }
  get order(): number {
    return super.get("order");
  }
  set order(value: number) {
    super.set("order", value);
  }
  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
  get title(): string {
    return super.get("title");
  }
  set title(value: string) {
    super.set("title", value);
  }
  get updatedBy(): _User {
    return super.get("updatedBy");
  }
  set updatedBy(value: _User) {
    super.set("updatedBy", value);
  }
  get user(): _User | undefined {
    return super.get("user");
  }
  set user(value: _User | undefined) {
    super.set("user", value);
  }
}

Parse.Object.registerSubclass("OD3_Documentation_Document", Document);
